import { useState } from 'react';

export const useIsMobileDevice = () => {
    const isMobileDeviceRegex = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const [isMobileDevice] = useState<boolean>(isMobileDeviceRegex);

    return isMobileDevice;
}